const mockStore = []

export const mockManager = {
  getStore () {
    return mockStore
  },
  add (url, responseData, method = 'GET', status = 200) {
    mockManager.remove(url, method)
    mockStore.push({
      method: method,
      url: url,
      response: {
        status: status,
        data: responseData
      }
    })
  },
  remove (url, method) {
    const index = mockStore.findIndex((response) => {
      return method.toLowerCase() === response.method.toLowerCase() &&
        url === response.url
    })
    if (index > -1) {
      mockStore.splice(index, 1)
    }
  },
  findByConfig (requestConfig) {
    return mockManager.find(requestConfig.url, requestConfig.method)
  },
  find (url, method) {
    return mockStore.find((response) => {
      return mockManager._match(response, { url, method })
    })
  },
  _match (response, { url, method }) {
    return method.toLowerCase() === response.method.toLowerCase() &&
      url.match(new RegExp(response.url))
  }
}

export function getMockResponse (mockError, msec = 1500) {
  const {mockData, config} = mockError
  const response = mockData.response
  if (typeof response.data === 'function') {
    response.data = response.data(config)
  }

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const logStyle = 'color: green; font-weight: bold;'

      console.group(`Mock API Request [${new Date().toLocaleString()}]`)
      console.log('%cMethod:', logStyle, mockData.method)
      console.log('%cStatus:', logStyle, response.status)
      console.log('%cUrl:', logStyle, config.url)
      // console.log('%cParams:', logStyle, JSON.stringify(config.params, null, '  '))
      // console.log('%cHeaders:', logStyle, JSON.stringify(config.headers, null, '  '))
      // console.log('%cData:', logStyle, response.data)
      console.groupEnd()

      // Handle mocked error (any non-2xx status code)
      if (response.status && String(response.status)[0] !== '2') {
        const err = new Error(response.message || String(response.data) || 'mock error')
        Object.assign(err, {
          config,
          response: response,
          code: response.status
        })
        return reject(err)
      }
      return resolve(Object.assign({
        data: {},
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        isMock: true
      }, response))
    }, msec)
  })
}
